import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService, HttpStatusCode } from '@serengeti/serengeti-common';
import { ToasterService } from 'angular2-toaster';
import { TranslateService } from '@ngx-translate/core';
import { LocaleComponent } from '../locale/locale.component';
import { environment } from 'src/environments/environment';
import { CodeService } from '@serengeti/serengeti-code';
// import { AuthService, GoogleLoginProvider } from "angularx-social-login";
import { OauthService } from 'src/app/oauth/service/oauth.service';
import { getOauthLoginActiveState } from 'src/app/app.module';
import { v4 as uuidv4 } from 'uuid';
import { NotificationService } from '@serengeti/serengeti-notification';
import { AppConfigService } from 'src/app/app-config.service';
import { HistoryService } from '@serengeti/serengeti-resource';
import {MenuService} from '@serengeti/serengeti-menu';
import {GuestUserService} from "@serengeti/serengeti-user";

@Component({
	selector: 'app-member-signin',
	templateUrl: './signin.component.html',
	styleUrls: ['./signin.component.css']
})
export class SignInComponent implements OnInit {

	public email: string;
	public password: string;
	public submitted = false;

	environment = environment;
	profile = environment.profile;

	model: any = {};
	loading = false;
	returnUrl: string;

	@ViewChild('locale', {static: false}) locale: LocaleComponent;

	@ViewChild('loginForm', {static: true}) private loginForm: NgForm;

	code : any;
	state : any;
	authorization : any;

	token : {
	  verification : string,
	  refreshToken : string,
	  email : string,
	  web : string,
	  name : string
	}

	apiOauthLoginState: boolean;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private translateService: TranslateService,
		private loginService: LoginService,
		private notificationService: NotificationService,
		private toasterService: ToasterService,
		private codeService: CodeService,
		private oauthService : OauthService,
		// private authService: AuthService,
		private guestUserService: GuestUserService,
		private appConfigService: AppConfigService,
		private historyService: HistoryService,
		private menuService: MenuService,
	) {
	}

	convertKeyCode($event: any) {
		console.log($event);
	}

	ngOnInit() {
    if (this.loginService.getLoginId()) {
      this.loginService.logout();
    }
		this.apiOauthLoginState = getOauthLoginActiveState();

		this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/';
		this.route.queryParams.subscribe(params => {
			if (params.code) {
				this.code = params.code;
				this.state = params.state;
				this.oauthService.access(this.code, this.state).subscribe(result =>
				  {
					this.authorization = result;
					this.loginWithNaver();
				  });
			}
		})
	}

	public onSubmit(): void {
		this.submitted = true;

		this.login(this.email, this.password, this.locale.value, false);
	}

	postLogin(user: any, oauthCreate: boolean) {
		this.codeService.find('SystemProfile', this.environment.profile).subscribe((profileContent: any) => {
			try {
				this.environment.content = JSON.parse(profileContent.detailInfo);
				this.loginService.setScreenConfig('login', 'profile', this.environment.content);
        this.loginService.setScreenConfig('toaster', 'toaster', 'Subscribe');
			} catch (error) {
				console.log(error);
				console.log(profileContent.detailInfo);
			}
			this.notificationService.connect(user.loginId);
			if (oauthCreate) {
				this.translateService.get(['home.signin.alert.oauth-create']).subscribe((messages: string) => {
					alert(messages['home.signin.alert.oauth-create']);
				});
			}
			this.historyService.count().subscribe(count=> {
				this.appConfigService.numberOfNotification = count;
			});
			this.menuService.roots().subscribe(menus => {
				this.appConfigService.menus = menus;
			});

			this.router.navigateByUrl(this.returnUrl);
		}, () => {
			this.router.navigateByUrl(this.returnUrl);
		});
	}

	postLoginError(error: any) {
		switch (error.status) {
		case HttpStatusCode.LOCKED:
			this.translateService.get(['home.signin.alert.locked','home.signin.title']).subscribe((messages: string) => {
				this.toasterService.pop('error', messages['home.signin.title'], messages['home.signin.alert.locked']);
			});
			break;

		case HttpStatusCode.UNAVAILABLE_FOR_LEGAL_REASONS:
			this.translateService.get(['home.signin.alert.deleted','home.signin.title']).subscribe((messages: string) => {
				this.toasterService.pop('error', messages['home.signin.title'], messages['home.signin.alert.deleted']);
			});
			break;

		default:
			this.translateService.get(['home.signin.alert.failed','home.signin.title']).subscribe((messages: string) => {
				this.toasterService.pop('major', messages['home.signin.title'], messages['home.signin.alert.failed']);
			});
			break;
		}
		this.loading = false;
	}

	public loginSucceed(res): void {
		this.loading = true;
		if (res.status === 'login') {
			this.postLogin(res, false);
		} else {
			this.loading = false;
		}
	}

	login(email, password, locale, oauthCreate) {
		if (this.loginForm.valid || email != null) {
			localStorage.setItem('locale', this.locale.value);

			this.loading = true;
			this.loginService.login(email, password, locale).subscribe((user) => {
				this.postLogin(user, oauthCreate);
			}, (error: any) => {
				this.postLoginError(error);
			});
		} else {
			if (this.loginForm.controls) {
				for (const control in this.loginForm.controls) {
					this.loginForm.controls[control].markAsTouched();
				}
			}
		}
	}

	oauthLogin(email, password, locale) {
		localStorage.setItem('locale', this.locale.value);

		this.loading = true;
		this.loginService.login(email, password, locale, true).subscribe((user) => {
			this.postLogin(user, true);
		}, (error: any) => {
			this.postLoginError(error);
		});
	}

	loginWithNaver() {
		this.oauthService.getUser(this.authorization).subscribe(result => {
			localStorage.setItem("naverAccessToken", this.authorization.access_token);
		  this.token = {
			verification : result.response.id,
			refreshToken : this.authorization.refresh_token,
			email : result.response.email,
			web : 'NAVER',
			name : result.response.name
		  }
		  this.validatedId();
		})
	  }

	  // loginWithGoogle() {
		//   this.authService.signIn(GoogleLoginProvider.PROVIDER_ID).then(result => {
		// 	this.token = {
		// 	  verification : result.id,
		// 	  refreshToken : result.idToken,
		// 	  email : result.email,
		// 	  web : 'GOOGLE',
		// 	  name : result.name
		// 	}
		// 	  this.validatedId();
		//   });
	  // }

	  validatedId() {
		const user = {
		  userId : this.token.email,
		  email: this.token.email,
		  userName : this.token.name,
		  password: this.token.verification,
		  status: 'Enabled',
		  roles: ['Developer'],
		  locale: 'ko-kr'
		};

		this.oauthService.validateId(this.token.email).subscribe(_ => {
			user.password = "!" + uuidv4().slice(0, 8);
			this.guestUserService.join(user).subscribe(_ =>{
			this.oauthService.createOauth(this.token.verification, this.token.refreshToken, this.token.email, this.token.web, user.userName, user.password).subscribe(_ => {
				this.login(user.email, user.password, user.locale, true);
			});
		  })
		}, error => {
		  this.oauthLogin(user.email, this.token.verification, user.locale);
		})
	  }

}
